import { createEnumFilter } from '@spotify/confidence-core-react';

import type { WorkflowInstanceStateType } from '../WorkflowInstanceState/types';

export const STATE_FILTER = createEnumFilter<WorkflowInstanceStateType>({
  id: 'state',
  label: 'State',
  field: 'state',
  enum: ['draft', 'live', 'ended', 'archived'],
});
